import {
  BabyChild,
  BabyBoy,
  BabyGirl,
  BabyBottle,
  Pacifier,
  ToysPuzzle,
  Stroller,
  BankBuilding,
  ClassicBuilding,
  CourtBuilding,
  HighRiseBuilding,
  HotelBuilding,
  HouseBuilding,
  ModernBuilding,
  SchoolBuilding,
  StoreBuilding,
  UniversityBuilding,
  Suitcase,
  Target,
  PieChart,
  SearchChart,
  Teamwork,
  Rocket,
  CleaningWoman,
  BuilderEmployee,
  Bubbles,
  WallBricks,
  CementCart,
  PencilRuler,
  ProjectPlanPen,
  Ruler,
  ScrewdriverRuler,
  ToolsHammer,
  ToolsWench,
  WenchRuler,
  ArchiveDocumentsBox,
  ArchiveLocker,
  OpenedBookWithText,
  OpenedBook,
  Book,
  Document,
  Pencil,
  PackageBox,
  Eye,
  Bell,
  Gear,
  Printer,
  RoomKey,
  Letter,
  User,
  UserBadge,
  UserDocument,
  UserGear,
  UserGroup,
  UserHexagon,
  Users,
  Moon,
  Sun,
  Bandage,
  Brush,
  BrushRuler,
  Feather,
  MagicWand,
  Magnet,
  Mailbox,
  Cube,
  Heart,
  Star,
  Triangle,
  Doctor,
  DoctorWoman,
  Nurse,
  HealthcareHome,
  Hospital,
  Bones,
  Brain,
  Drugs,
  HeartCheckmark,
  MedicalBook,
  MedicalCase,
  Siren,
  Stethoscope,
  Syringe,
  Teeth,
} from 'components/icons'

const OUTLINES_ICONS = [
  {
    value: 'BabyChild',
    icon: BabyChild,
  },
  {
    value: 'BabyBoy',
    icon: BabyBoy,
  },
  {
    value: 'BabyGirl',
    icon: BabyGirl,
  },
  {
    value: 'BabyBottle',
    icon: BabyBottle,
  },
  {
    value: 'Pacifier',
    icon: Pacifier,
  },
  {
    value: 'ToysPuzzle',
    icon: ToysPuzzle,
  },
  {
    value: 'Stroller',
    icon: Stroller,
  },
  {
    value: 'BankBuilding',
    icon: BankBuilding,
  },
  {
    value: 'ClassicBuilding',
    icon: ClassicBuilding,
  },
  {
    value: 'CourtBuilding',
    icon: CourtBuilding,
  },
  {
    value: 'HighRiseBuilding',
    icon: HighRiseBuilding,
  },
  {
    value: 'HotelBuilding',
    icon: HotelBuilding,
  },
  {
    value: 'HouseBuilding',
    icon: HouseBuilding,
  },
  {
    value: 'ModernBuilding',
    icon: ModernBuilding,
  },
  {
    value: 'SchoolBuilding',
    icon: SchoolBuilding,
  },
  {
    value: 'StoreBuilding',
    icon: StoreBuilding,
  },
  {
    value: 'UniversityBuilding',
    icon: UniversityBuilding,
  },
  {
    value: 'Suitcase',
    icon: Suitcase,
  },
  {
    value: 'Target',
    icon: Target,
  },
  {
    value: 'PieChart',
    icon: PieChart,
  },
  {
    value: 'SearchChart',
    icon: SearchChart,
  },
  {
    value: 'Teamwork',
    icon: Teamwork,
  },
  {
    value: 'Rocket',
    icon: Rocket,
  },
  {
    value: 'Bubbles',
    icon: Bubbles,
  },
  {
    value: 'CleaningWoman',
    icon: CleaningWoman,
  },
  {
    value: 'BuilderEmployee',
    icon: BuilderEmployee,
  },
  {
    value: 'WallBricks',
    icon: WallBricks,
  },
  {
    value: 'CementCart',
    icon: CementCart,
  },
  {
    value: 'ProjectPlanPen',
    icon: ProjectPlanPen,
  },
  {
    value: 'Ruler',
    icon: Ruler,
  },
  {
    value: 'PencilRuler',
    icon: PencilRuler,
  },
  {
    value: 'ScrewdriverRuler',
    icon: ScrewdriverRuler,
  },
  {
    value: 'ToolsHammer',
    icon: ToolsHammer,
  },
  {
    value: 'ToolsWench',
    icon: ToolsWench,
  },
  {
    value: 'WenchRuler',
    icon: WenchRuler,
  },
  {
    value: 'ArchiveDocumentsBox',
    icon: ArchiveDocumentsBox,
  },
  {
    value: 'ArchiveLocker',
    icon: ArchiveLocker,
  },
  {
    value: 'OpenedBookWithText',
    icon: OpenedBookWithText,
  },
  {
    value: 'OpenedBook',
    icon: OpenedBook,
  },
  {
    value: 'Book',
    icon: Book,
  },
  {
    value: 'Document',
    icon: Document,
  },
  {
    value: 'Pencil',
    icon: Pencil,
  },
  {
    value: 'PackageBox',
    icon: PackageBox,
  },
  {
    value: 'Eye',
    icon: Eye,
  },
  {
    value: 'Bell',
    icon: Bell,
  },
  {
    value: 'Gear',
    icon: Gear,
  },
  {
    value: 'Printer',
    icon: Printer,
  },
  {
    value: 'RoomKey',
    icon: RoomKey,
  },
  {
    value: 'Letter',
    icon: Letter,
  },
  {
    value: 'User',
    icon: User,
  },
  {
    value: 'UserBadge',
    icon: UserBadge,
  },
  {
    value: 'UserDocument',
    icon: UserDocument,
  },
  {
    value: 'UserGear',
    icon: UserGear,
  },
  {
    value: 'UserGroup',
    icon: UserGroup,
  },
  {
    value: 'UserHexagon',
    icon: UserHexagon,
  },
  {
    value: 'Users',
    icon: Users,
  },
  {
    value: 'Moon',
    icon: Moon,
  },
  {
    value: 'Sun',
    icon: Sun,
  },
  {
    value: 'Brush',
    icon: Brush,
  },
  {
    value: 'BrushRuler',
    icon: BrushRuler,
  },
  {
    value: 'Feather',
    icon: Feather,
  },
  {
    value: 'MagicWand',
    icon: MagicWand,
  },
  {
    value: 'Magnet',
    icon: Magnet,
  },
  {
    value: 'Mailbox',
    icon: Mailbox,
  },
  {
    value: 'Cube',
    icon: Cube,
  },
  {
    value: 'Heart',
    icon: Heart,
  },
  {
    value: 'Star',
    icon: Star,
  },
  {
    value: 'Triangle',
    icon: Triangle,
  },
  {
    value: 'Bandage',
    icon: Bandage,
  },
  {
    value: 'Doctor',
    icon: Doctor,
  },
  {
    value: 'DoctorWoman',
    icon: DoctorWoman,
  },
  {
    value: 'Nurse',
    icon: Nurse,
  },
  {
    value: 'HealthcareHome',
    icon: HealthcareHome,
  },
  {
    value: 'Hospital',
    icon: Hospital,
  },
  {
    value: 'Bones',
    icon: Bones,
  },
  {
    value: 'Brain',
    icon: Brain,
  },
  {
    value: 'Drugs',
    icon: Drugs,
  },
  {
    value: 'HeartCheckmark',
    icon: HeartCheckmark,
  },
  {
    value: 'MedicalBook',
    icon: MedicalBook,
  },
  {
    value: 'MedicalCase',
    icon: MedicalCase,
  },
  {
    value: 'Siren',
    icon: Siren,
  },
  {
    value: 'Stethoscope',
    icon: Stethoscope,
  },
  {
    value: 'Syringe',
    icon: Syringe,
  },
  {
    value: 'Teeth',
    icon: Teeth,
  },
]

export default OUTLINES_ICONS
